import { render, staticRenderFns } from "./NoPassList.vue?vue&type=template&id=8532e22e&scoped=true"
import script from "./NoPassList.vue?vue&type=script&lang=js"
export * from "./NoPassList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8532e22e",
  null
  
)

export default component.exports